import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export function setLearningRoom(learningRoom) {
    return { type: "SET_LEARNING_ROOM", learningRoom};
}

export function getLearningRoom() {
    return dispatch => {
        Common.reactLoader("show", "please wait...");
        fetch(Config.domainUrl+'guidedpath/glearning', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },
            body: JSON.stringify({
                learner_id: User.UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            dispatch(setLearningRoom(responseJson.learningroom));
            //Common.reactLoader("hide");
        }).catch(error => {
            console.error(error);            
        });
     
    };
}


// WEBPACK FOOTER //
// ./src/actions/learningRoomAction.js